import * as React from 'react';
import { initials } from '@/lib/initials';

const PALETTE = [
  'bg-amber-100 text-amber-800',
  'bg-sky-100 text-sky-800',
  'bg-emerald-100 text-emerald-800',
  'bg-violet-100 text-violet-800',
  'bg-rose-100 text-rose-800',
  'bg-teal-100 text-teal-800',
];


function tint(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

interface Props {
  name: string;
  photoUrl?: string | null;
  className?: string;
}

export default function ChatAvatar({ name, photoUrl, className = 'h-8 w-8' }: Props) {
  const [broken, setBroken] = React.useState(false);

  React.useEffect(() => setBroken(false), [photoUrl]);

  if (photoUrl && !broken) {
    return (
      <img
        src={photoUrl}
        alt=""
        onError={() => setBroken(true)}
        className={`${className} shrink-0 rounded-full border object-cover`}
        data-testid="chat-avatar-photo"
      />
    );
  }

  return (
    <span
      aria-hidden
      className={`${className} shrink-0 select-none rounded-full ${tint(name)} flex items-center justify-center text-[11px] font-semibold`}
      data-testid="chat-avatar-initials"
    >
      {initials(name)}
    </span>
  );
}
